import { Modal, Button, Badge } from 'react-bootstrap';
import { File } from '../../../types/knowledge-base.ts';

interface DetailsModalProps {
    show: boolean;
    file: File | null;
    onHide: () => void;
    isAdmin: boolean;
    formatFileSize: (size: number) => string;
}

export const DetailsModal: React.FC<DetailsModalProps> = ({
                                                              show,
                                                              file,
                                                              onHide,
                                                              isAdmin,
                                                              formatFileSize
                                                          }) => {
    if (!file) return null;

    const formatDate = (dateString: string | undefined): string => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch {
            return 'N/A';
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>File Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h6>Name</h6>
                    <p>{file.name}</p>

                    <h6>Size</h6>
                    <p>{formatFileSize(file.fileSize)}</p>

                    <h6>Type</h6>
                    <p>{file.mimeType}</p>

                    {file.description && (
                        <>
                            <h6>Description</h6>
                            <p>{file.description}</p>
                        </>
                    )}

                    <h6>Access Level</h6>
                    <p>
                        {file.isOwner ? 'Owner' : (file.canManage || isAdmin ? 'Manager' : 'Viewer')}
                    </p>

                    {file.groupAccess && file.groupAccess.length > 0 && (
                        <>
                            <h6>Shared with Groups</h6>
                            <div className="d-flex flex-wrap gap-2">
                                {file.groupAccess.map((groupName, index) => (
                                    <Badge
                                        key={index}
                                        bg="info"
                                    >
                                        {groupName}
                                    </Badge>
                                ))}
                            </div>
                        </>
                    )}

                    <h6>Created</h6>
                    <p>{formatDate(file.created_at)}</p>

                    <h6>Last Modified</h6>
                    <p>{formatDate(file.updated_at)}</p>

                    <h6>Uploaded By</h6>
                    <p>{file.uploadedBy || 'N/A'}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DetailsModal;